import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { ClickTracker } from "@xo-union/tk-component-analytics";
import { useClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import { ScreenReaderOnly } from "@xo-union/ui-accessibility";
import { Caption } from "@xo-union/tk-ui-typography";
import styles from "./styles.css";
const SubNavContainer = _ref => {
  let {
    analyticsProps,
    children,
    classes: classesProp,
    links
  } = _ref;
  const classes = useClasses(styles, classesProp);
  return /*#__PURE__*/React.createElement(ClickTracker, _extends({
    eventName: "Sub Nav Interaction"
  }, analyticsProps), /*#__PURE__*/React.createElement(Caption, {
    as: "nav",
    "aria-labelledby": "sub-nav",
    className: classes['sub-nav-container']
  }, /*#__PURE__*/React.createElement(ScreenReaderOnly, {
    id: "sub-nav"
  }, "Secondary Navigation Menu"), /*#__PURE__*/React.createElement("ul", {
    className: classes['sub-nav-item-list'],
    role: "list"
  }, links), children));
};
process.env.NODE_ENV !== "production" ? SubNavContainer.propTypes = {
  /**
   * Props for analytics component. See [@xo-union/tk-component-analytics](/packages/@xo-union/tk-component-analytics)
   */
  analyticsProps: PropTypes.shape({
    product: PropTypes.string.isRequired
  }),
  children: PropTypes.node,
  classes: classesPropType(),
  /**
   * `SubNavLink` and `SubNavButton` nodes to render as a list of left-aligned labels in the sub nav
   */
  links: PropTypes.node.isRequired
} : void 0;
SubNavContainer.defaultProps = {
  analyticsProps: {}
};
export default SubNavContainer;